import axios from 'axios'
import {
    CADASTRAR_USUARIOS_EMPRESA_EM_LOTE,
    LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE,
    HABILITADO_PAGAMENTO_POS, HABILITADO_PAGAMENTO_TEF, HABILITADO_PAGAMENTO_LINK,
    HABILITADO_CIELO_ECOMMERCE, HABILITADO_SICOOB, HABILITADO_STONE_CONNECT
} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import {URL} from '../../util/ambienteActions';

const CACHE_PREFIX = 'vexado_pagamento_hab_';

const OFFLINE_AWARE_CONFIG = {
    headers: {
        ...SLOW_REQUEST_CONFIG.headers,
        [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
    }
}

function habilitadoOffline(type, chave, dispatch) {
    try {
        const cache = localStorage.getItem(chave);
        if (cache !== null) return dispatch({ type, payload: { data: JSON.parse(cache) } });
    } catch (_) { // ignore
    }
    return dispatch({ type, payload: { data: false } });
}

export function cadastrarUsuariosEmpresaEmLote(parametros) {
    const url = `${URL}/usuarios-empresa/cadastrar-em-lote`;
    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_USUARIOS_EMPRESA_EM_LOTE,
            payload: response
        })
    );
}

export function usuarioEmpresaHabilitadoPagamentoViaPOS(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-pagamento-via-pos`;
    const chave = `${CACHE_PREFIX}pos_${idEmpresa}`;
    return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
        .then(response => {
            try { localStorage.setItem(chave, JSON.stringify(response.data)); } catch (_) { // ignore
            }
            return dispatch({ type: HABILITADO_PAGAMENTO_POS, payload: response });
        })
        .catch(erro => {
            if (!navigator.onLine || !erro.response) return habilitadoOffline(HABILITADO_PAGAMENTO_POS, chave, dispatch);
            throw erro;
        });
}

export function usuarioEmpresaHabilitadoPagamentoViaTEF(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-pagamento-via-tef`;
    const chave = `${CACHE_PREFIX}tef_${idEmpresa}`;
    return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
        .then(response => {
            try { localStorage.setItem(chave, JSON.stringify(response.data)); } catch (_) { // ignore
            }
            return dispatch({ type: HABILITADO_PAGAMENTO_TEF, payload: response });
        })
        .catch(erro => {
            if (!navigator.onLine || !erro.response) return habilitadoOffline(HABILITADO_PAGAMENTO_TEF, chave, dispatch);
            throw erro;
        });
}

export function usuarioEmpresaHabilitadoPagamentoViaLink(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-pagamento-via-link`;
    const chave = `${CACHE_PREFIX}link_${idEmpresa}`;
    return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
        .then(response => {
            try { localStorage.setItem(chave, JSON.stringify(response.data)); } catch (_) { // ignore
            }
            return dispatch({ type: HABILITADO_PAGAMENTO_LINK, payload: response });
        })
        .catch(erro => {
            if (!navigator.onLine || !erro.response) return habilitadoOffline(HABILITADO_PAGAMENTO_LINK, chave, dispatch);
            throw erro;
        });
}

export function usuarioEmpresaHabilitadoCieloEcommerce(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-cielo-ecommerce`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: HABILITADO_CIELO_ECOMMERCE,
            payload: response
        })
    );
}

export function usuarioEmpresaHabilitadoSicoob(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-sicoob`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: HABILITADO_SICOOB,
            payload: response
        })
    );
}

export function usuarioEmpresaHabilitadoStoneConnect(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-stone-connect`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: HABILITADO_STONE_CONNECT,
            payload: response
        })
    );
}

export function limparRetornocadastramentoUsuariosEmpresaEmLote() {
    return {
        type: LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE
    }
}
